import { Form, type FormItemProps, Input } from "antd";
import type { InputProps } from "antd/lib";
import { FormItem } from "~components/Form/FormItem";
import { createNumberOnChange } from "~utilities/createNumberOnChange";
import type { EditFixtureForm } from "../../types";
import { StyledFixtureScoreSkeleton, StyledInputsContainer, StyledMainLabel } from "./FixtureScore.styles";

type Side<TForm> = {
  label: string;
  name?: FormItemProps<TForm>["name"];
};

type Props<TForm> = {
  awayProps: Side<TForm> | null;
  disabled: boolean;
  homeProps: Side<TForm> | null;
  label: string;
  showSkeleton: boolean;
};

export const FixtureScore = <TForm = unknown>({ awayProps, disabled, homeProps, label, showSkeleton }: Props<TForm>) => {
  const labelHtmlFor = homeProps?.name || awayProps?.name;
  const htmlFor = Array.isArray(labelHtmlFor) ? labelHtmlFor.join("_") : (labelHtmlFor as string);

  const sharedInputProps: InputProps = {
    size: "small",
    min: 0,
    maxLength: 6,
    disabled,
    inputMode: "numeric",
    pattern: "[0-9]*",
  };

  const form = Form.useFormInstance<EditFixtureForm>();

  return (
    <div>
      <StyledMainLabel htmlFor={htmlFor}>{label}</StyledMainLabel>

      {showSkeleton ? (
        <StyledFixtureScoreSkeleton active />
      ) : (
        <StyledInputsContainer>
          <div>
            {homeProps && (
              <FormItem<TForm> {...homeProps} colon={false}>
                <Input
                  {...sharedInputProps}
                  onChange={createNumberOnChange((value) => {
                    form.setFieldsValue({ [homeProps.name as string]: value });
                  })}
                />
              </FormItem>
            )}
          </div>
          <div>
            {awayProps && (
              <FormItem<TForm> {...awayProps} colon={false}>
                <Input
                  {...sharedInputProps}
                  onChange={createNumberOnChange((value) => {
                    form.setFieldsValue({ [awayProps.name as string]: value });
                  })}
                />
              </FormItem>
            )}
          </div>
        </StyledInputsContainer>
      )}
    </div>
  );
};
